import PropTypes from 'prop-types';
import React, { Component, useState } from 'react';
import { Card, CardHeader, Collapse } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { QUESTION_INPUT_TYPES } from 'constants/index';
import ReportAnswerList from 'components/reports/ReportAnswerList';
import ChartReportModal from './ChartReportModal';
import NPSAnswersList from './nps/AnswersReport';
import CommentAnswers from './comment/commentAnswers';
import AdvancedReport from '../advancedReport/advancedReport';

const AnswersList = ({
  question,
  dateRange,
  collapse,
  toggleChartReport,
  advancedReportVisible,
  showAdvancedReport,
}) => {
  let display = null;
  if (question.input_type === QUESTION_INPUT_TYPES.NPS) {
    display = <NPSAnswersList question={question} />;
  } else if (question.input_type === QUESTION_INPUT_TYPES.COMMENT) {
    display = <CommentAnswers comments={question.comments} />;
  } else {
    display = question.answers.map(answer => {
      return (
        <ReportAnswerList
          participants_count={question.participants_count}
          answer={answer}
          dateRange={dateRange}
        />
      );
    });
  }

  return (
    <Collapse isOpen={collapse} key={question.question_id}>
      {showAdvancedReport && (
        <AdvancedReport
          toggleChartReport={toggleChartReport}
          advancedReportVisible={advancedReportVisible}
          dateRange={dateRange}
          questionId={question.question_id}
          isSurveyTemplateQuestion={question.survey_template_question_id}
        />
      )}
      {!advancedReportVisible && display}
    </Collapse>
  );
};
class ReportDisplay extends Component {
  constructor() {
    super();
    this.state = {
      collapse: false,
      advancedReportVisible: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.setState({
      collapse: this.props.collapseReport,
    });
  }

  toggleChartReport = e => {
    e.stopPropagation();
    this.setState(prevstate => ({
      advancedReportVisible: !prevstate.advancedReportVisible,
    }));
  };

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    const { question, match, dateRange, isPublic } = this.props;
    const { customSurveyId } = match.params;
    const { advancedReportVisible, collapse } = this.state;
    const isNPSQuestion = question.input_type === QUESTION_INPUT_TYPES.NPS;

    return (
      <Card
        id="download-reports"
        key={question.question_id}
        className="bg-white reports-container styled-box-shadow"
      >
        <CardHeader
          onClick={this.toggle}
          className="bg-white cursor-pointer"
          key={question.question_id}
        >
          <div className="row justify-content-between px-3">
            <h6 className="d-inline-block mb-0">{question.question}</h6>
            <div className="float-right d-flex text-muted">
              <span>
                <FontAwesomeIcon className="mr-0" icon="users" />{' '}
                {question.participants_count}
              </span>
            </div>
          </div>
        </CardHeader>
        <AnswersList
          question={question}
          isNPSQuestion={isNPSQuestion}
          dateRange={dateRange}
          collapse={collapse}
          toggleChartReport={this.toggleChartReport}
          advancedReportVisible={advancedReportVisible}
          showAdvancedReport={customSurveyId && !isPublic}
        />
      </Card>
    );
  }
}

ReportDisplay.propTypes = {
  collapseReport: PropTypes.bool,
  onDateChange: PropTypes.func,
  dateRange: PropTypes.object,
  question: PropTypes.object,
  isPublic: PropTypes.bool,
};

export default withRouter(ReportDisplay);



// WEBPACK FOOTER //
// ./src/components/reports/ReportDisplay.js